import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { LanguageSwitcherInterface } from 'common/types/entities/LanguageSwitcherInterface'
import React from 'react'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import TextFontUpdater from '../components/Font/TextFontUpdater'
import Input from '../components/Input/Input'
import LanguageCheckList from '../components/LanguageCheckList'
import { useUpdateEntity, useUpdateProp } from '../hooks/useUpdateProps'
import DeviceAppearanceNew from '../options/DeviceAppearance/DeviceAppearanceNew'
import TextFontSize from '../styles/TextFontSize'
import TextLineHeight from '../styles/TextLineHeight'

function NewLanguageSwitcherSettings({
  entity,
  defaultEntity,
}: {
  entity: LanguageSwitcherInterface
  defaultEntity?: LanguageSwitcherInterface
}) {
  const { isMobile } = useDeviceModeContext()
  const updateEntity = useUpdateEntity<LanguageSwitcherInterface>()
  const updateProp = useUpdateProp(entity)

  const handleExcludeLanguages = (excludedLanguages: string[]) => {
    updateEntity({
      ...entity,
      excludedLanguages: excludedLanguages,
    })
  }

  return (
    <React.Fragment>
      <Input
        label="entity_settings.language_switcher.redirect_path"
        value={entity.redirectPath}
        update={updateProp('redirectPath')}
      />
      <GroupTitle>
        entity_settings.language_switcher.available_languages
      </GroupTitle>
      <LanguageCheckList
        update={handleExcludeLanguages}
        excludeLanguagesList={entity.excludedLanguages}
      />
      <GroupTitle>typography</GroupTitle>
      {/* @ts-ignore */}
      <TextFontSize
        update={updateProp('fontSize')}
        mobileUpdate={updateProp('mobileFontSize')}
        fontSize={entity.fontSize}
        mobileFontSize={entity.mobileFontSize}
        removeEntityStyle={updateProp('fontSize')}
        removeEntityMobileStyle={updateProp('mobileFontSize')}
      />
      <TextLineHeight
        fontSize={entity.fontSize}
        mobileFontSize={entity.mobileFontSize}
        update={updateProp('lineHeight')}
        mobileUpdate={updateProp('mobileLineHeight')}
        lineHeight={entity.lineHeight}
        mobileLineHeight={entity.mobileLineHeight}
        removeEntityStyle={updateProp('lineHeight')}
        removeEntityMobileStyle={updateProp('mobileLineHeight')}
      />
      <TextFontUpdater<LanguageSwitcherInterface>
        entity={entity}
        update={updateEntity}
      />
      <ColorPickerControl
        update={updateProp('color')}
        mobileUpdate={updateProp('mobileColor')}
        color={entity.color}
        mobileColor={entity.mobileColor}
        label="text color"
      />
      <SizeAndPositionGroup
        margin={isMobile ? entity.mobileMargin : entity.margin}
        defaultMargin={
          isMobile ? defaultEntity?.mobileMargin : defaultEntity?.margin
        }
        updateMargin={updateProp(isMobile ? 'mobileMargin' : 'margin')}
      />
      <DeviceAppearanceNew entity={entity} />
    </React.Fragment>
  )
}

export default NewLanguageSwitcherSettings
